const address = {
	name: 'Adresse',
	icon: 'fa-solid fa-location-dot',
	fields: {
		street: 'Straße',
		zip: 'PLZ | Postleitzahl',
		city: 'Ort | Stadt',
		country: 'Land',
	},
}

export default address
